import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { RegionListResponse } from '../interfaces/responses/models';

@Injectable({
  providedIn: 'root'
})
export class RegionService {
  private apiUrl = environment.apiUrl + 'regions/';

  constructor(private http: HttpClient) { }

  private createCompleteUrl(path: string): string {
    return `${this.apiUrl}${path}`;
  }

  getStates(): Observable<RegionListResponse> {
    return this.http.get<RegionListResponse>(this.apiUrl);
  }
}
